import moment from 'moment';
import echarts from 'echarts';
import L from 'leaflet';
import Vue from 'vue';
import store from '../store';

export function loadScript(url) {
  return new Promise((resolve, reject) => {
    //console.log('load script1', url);
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.onload = script.onreadystatechange = function() {
      if (
        !this.readyState || // 现代浏览器没有 readyState
        this.readyState == 'loaded' ||
        this.readyState == 'complete' // 这是IE的判断语句
      ) {
        resolve();
      }
    };
    script.onerror = () => reject();
    document.head.appendChild(script); //塞进页面
  });
}

/**
 * 样式文件不关心顺序
 */
export function loadStyle(url) {
  //console.log('load style', url);
  const link = document.createElement('link');
  link.href = url;
  document.head.appendChild(link);
}

function parseQuery(str) {
  if (!str) return {};
  const index = str.indexOf('?');
  if (index === -1) return {};
  const query = str.slice(index + 1);
  return query.split('&').reduce((acc, keyVal) => {
    if (!keyVal) return acc;
    const arr = keyVal.split('=');
    acc[arr[0]] = arr[1];
    return acc;
  }, {});
}

export function serializer(obj) {
  let str = Object.keys(obj).reduce((acc, c) => {
    acc = acc + '&' + [c] + '=' + obj[c];
    return acc;
  }, '');

  return str.slice(1);
}

export function safeGetStorage(key) {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    return '';
  }
}

export function safeSetStorage(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch (e) {
    //console.log('e', e);
  }
}

export function safeGetSessionStorage(key) {
  try {
    return sessionStorage.getItem(key);
  } catch (e) {
    return '';
  }
}

export function safeSetSessionStorage(key, value) {
  try {
    sessionStorage.setItem(key, value);
  } catch (e) {
    //console.log('e', e);
  }
}

export function getToken() {
  return safeGetStorage('apiKey') || 'gyEXZbYJ614b69mEH187M06X6tPoWF67';
}

export function setToken(token) {
  return safeSetStorage('apiKey', token);
}

export function getParam() {
  return {
    ...parseQuery(location.search),
    ...parseQuery(location.hash)
  };
}

export function safeParse(str) {
  try {
    return JSON.parse(str);
  } catch (e) {
    console.warn('json parse error', e);
    return null;
  }
}

export function safeStringify(obj) {
  try {
    return JSON.stringify(obj);
  } catch (e) {
    console.warn('json stringify error', e);
    return '';
  }
}

export function getIntergrityInterval(arr, refArr = [], index, extra) {
  let newArr = [];
  let currentStartIndex = null;
  let currentEndIndex = null;
  let prev = 0;
  let i = 0;

  let length = arr.length;

  while (i < length) {
    const val = arr[i];

    if (val === 0) {
      if (prev === 0) {
        i++;
        prev = val;
        continue;
      }

      if (prev === 1) {
        currentEndIndex = refArr[i];
      }
    }

    if (val === 1) {
      if (prev === 0) {
        currentStartIndex = refArr[i];
      }

      if (prev === 1) {
        if (i !== length - 1) {
          i++;
          prev = val;
          continue;
        } else {
          currentEndIndex = refArr[i];
        }
        // i++;
      }
    }

    if (currentStartIndex !== null && currentEndIndex !== null) {
      newArr.push({
        value: [
          index,
          moment(currentStartIndex).valueOf(),
          moment(currentEndIndex).valueOf()
        ],
        itemStyle: extra
      });
      currentStartIndex = null;
      currentEndIndex = null;
    }
    i++;
    prev = val;
  }

  return newArr;
}

export async function getDataURLByEchartOptions(options, divOption = {}) {
  const { width = '500px', height = '300px', notMerge = false } = divOption;
  const div = document.createElement('div');
  div.style.width = width;
  div.style.height = height;
  const myChart = echarts.init(div);

  myChart.setOption(options, notMerge);

  return new Promise(resolve => {
    setTimeout(() => {
      resolve(
        myChart.getDataURL({
          pixelRatio: 2
        })
      );
    }, 2000);
  });
}

export function hasPermission(/** user, code */) {
  // todo: 权限功能后台还没有，先默认返回true
  return true;
  // const codes = user?.functionMenu || [];
  // return Boolean(codes.find(codeItem => codeItem.functionCode === code));
}

export function isInteger(obj) {
  return obj % 1 === 0;
}

export function isObject(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

export function findDeepId(data) {
  if (Array.isArray(data)) {
    const firstItem = data[0];
    return findDeepId(firstItem);
  } else {
    if (isObject(data)) {
      return data.id;
    } else {
      return '';
    }
  }
}

export function downLoadFile(url) {
  const iframe = document.createElement('iframe');
  iframe.src = url;
  document.body.append(iframe);

  iframe.style.display = 'none';

  //setTimeout(() => {
  //document.body.removeChild(iframe);
  //}, 2000);
}

export function getUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    return (c === 'x' ? (Math.random() * 16) | 0 : 'r&0x3' | '0x8').toString(
      16
    );
  });
}

export class Pop {
  constructor(component, map, options = {}) {
    this.pop = L.popup({
      autoClose: false,
      closeButton: false,
      closeOnClick: true,
      className: 'fengge-popup-content',
      keepInView: false,
      ...options
    });
    this.rootId = parseInt(Math.random() * 10000);
    this.rootTemplate = `<div id="pop_${this.rootId}"></div>`;
    this.component = component;
    this.map = map;
  }

  createContent(data = {}, callback = () => {}) {
    const { lat, lng, height } = data;

    this.pop
      .setLatLng({
        lat: lat,
        lng: lng
      })
      .setContent(this.rootTemplate)
      .openOn(this.map);

    const el = document.querySelector(`#pop_${this.rootId}`);

    if (height) {
      document.querySelectorAll('.fengge-popup-content').forEach(i => {
        i.style.height = height;
      });
    }

    Promise.resolve()
      .then(() => {
        this.currentVue = new Vue({
          name: 'pop',
          store,
          render: h =>
            h(this.component, {
              attrs: data
            }),
          el: el
        });
      })
      .then(callback);

    return this.pop;
  }

  clear() {
    this.pop.remove();
    this.currentVue.$destroy();
  }
}

/**
 * 根据一个经纬度及距离角度，算出另外一个经纬度
 * @param {*} lng 经度 113.3960698
 * @param {*} lat 纬度 22.941386
 * @param {*} brng 方位角 45 ---- 正北方：000°或360° 正东方：090° 正南方：180° 正西方：270°
 * @param {*} dist 90000距离(米)
 *
 * 1、角度转换为弧度公式：弧度=角度×(π ÷度180 )
 * 2、弧度转换为角度公式： 角度=弧度×（180÷π）
 */
export function getLonAndLat(lng, lat, brng, dist) {
  //大地坐标系资料WGS-84 长半径a=6378137 短半径b=6356752.3142 扁率f=1/298.2572236
  var a = 6378137;
  var b = 6356752.3142;
  var f = 1 / 298.257223563;

  var lon1 = lng * 1;
  var lat1 = lat * 1;
  var s = dist;
  var alpha1 = brng * (Math.PI / 180); //mapNumberUtil.rad(brng);
  var sinAlpha1 = Math.sin(alpha1);
  var cosAlpha1 = Math.cos(alpha1);

  //var tanU1 = (1 - f) * Math.tan(mapNumberUtil.rad(lat1));
  var tanU1 = (1 - f) * Math.tan(lat1 * (Math.PI / 180));
  var cosU1 = 1 / Math.sqrt(1 + tanU1 * tanU1),
    sinU1 = tanU1 * cosU1;
  var sigma1 = Math.atan2(tanU1, cosAlpha1);
  var sinAlpha = cosU1 * sinAlpha1;
  var cosSqAlpha = 1 - sinAlpha * sinAlpha;
  var uSq = (cosSqAlpha * (a * a - b * b)) / (b * b);
  var A = 1 + (uSq / 16384) * (4096 + uSq * (-768 + uSq * (320 - 175 * uSq)));
  var B = (uSq / 1024) * (256 + uSq * (-128 + uSq * (74 - 47 * uSq)));

  var sigma = s / (b * A),
    sigmaP = 2 * Math.PI;
  while (Math.abs(sigma - sigmaP) > 1e-12) {
    var cos2SigmaM = Math.cos(2 * sigma1 + sigma);
    var sinSigma = Math.sin(sigma);
    var cosSigma = Math.cos(sigma);
    var deltaSigma =
      B *
      sinSigma *
      (cos2SigmaM +
        (B / 4) *
          (cosSigma * (-1 + 2 * cos2SigmaM * cos2SigmaM) -
            (B / 6) *
              cos2SigmaM *
              (-3 + 4 * sinSigma * sinSigma) *
              (-3 + 4 * cos2SigmaM * cos2SigmaM)));
    sigmaP = sigma;
    sigma = s / (b * A) + deltaSigma;
  }

  var tmp = sinU1 * sinSigma - cosU1 * cosSigma * cosAlpha1;
  var lat2 = Math.atan2(
    sinU1 * cosSigma + cosU1 * sinSigma * cosAlpha1,
    (1 - f) * Math.sqrt(sinAlpha * sinAlpha + tmp * tmp)
  );
  var lambda = Math.atan2(
    sinSigma * sinAlpha1,
    cosU1 * cosSigma - sinU1 * sinSigma * cosAlpha1
  );
  var C = (f / 16) * cosSqAlpha * (4 + f * (4 - 3 * cosSqAlpha));
  var L =
    lambda -
    (1 - C) *
      f *
      sinAlpha *
      (sigma +
        C *
          sinSigma *
          (cos2SigmaM + C * cosSigma * (-1 + 2 * cos2SigmaM * cos2SigmaM)));

  // var revAz = Math.atan2(sinAlpha, -tmp); // final bearing

  var lngLatObj = {
    lng: lon1 + L * (180 / Math.PI),
    lat: lat2 * (180 / Math.PI)
  };
  return lngLatObj;
};
